import { IItem } from '../../timeline/store/timeline.types'
import { IHospitalNotifyState } from '../../procedures/hospitalNotify/store/hospitalNotify.types'
import { TabConstants } from '../../../components/tabs/Tabs.constants'
import { TimelineConstants } from '../../timeline/store/timeline.constants'
import { IOptions } from '../../../common/common.types'
import { IEKGEvent } from '../store/ekgImport.types'
import { generateClientCorrelationId } from '../../nemsisData/utils/customElements.util'
import { INemsisSnomedLookup } from '../../../components/procedure/store/procedure.types'
import { getUpdatedProcedureStateWithNemsisCode, handleNemsisCodeError } from '../../../utilities/nemsisCode.util'

interface CreateHospitalNotifyProcedureProps {
  procedureEvent: IEKGEvent
  hospitalNotifyOptions: IOptions
  ptaCutoff: Date | null
  nemsisCodeOptions: INemsisSnomedLookup[]
}

export interface HospitalNotifyProcedureObject {
  timelineItem: IItem
  hospitalNotifyState: IHospitalNotifyState
}

const createHospitalNotifyProcedure = (props: CreateHospitalNotifyProcedureProps): HospitalNotifyProcedureObject => {
  const { procedureEvent, hospitalNotifyOptions, ptaCutoff, nemsisCodeOptions } = props

  const clientEventId = (procedureEvent.eventVitals.clientEventId as number).toString()
  const vsAction = procedureEvent.eventVitals.vsAction
  const isEkgImport = procedureEvent.eventVitals.isEkgImport

  const methodOption = hospitalNotifyOptions.find((option) => option.name === procedureEvent.procedureAction)
  const itemComments = procedureEvent.procedureComments || ''
  const itemSubHeader = `By , Comments: ${itemComments}.`

  const eventDate = new Date(procedureEvent.dtDevice)
  const isPTA = !!ptaCutoff && eventDate < ptaCutoff

  const clientCorrelationId = generateClientCorrelationId(
    nemsisCodeOptions,
    TimelineConstants.HOSPITAL_NOTIFY_PROCEDURE,
    methodOption?.name || '',
    {
      filter1: null,
      filter2: null,
      filter3: null,
    },
    clientEventId
  )

  const timelineItem: IItem = {
    key: clientEventId,
    clientCorrelationId,
    itemType: 'Procedures',
    event: 'Hospital Notify',
    grid: true,
    labelHeaderFlag: isPTA ? 'PTA' : '',
    labelHeader: procedureEvent.eventVitals.time,
    subHeader: procedureEvent.eventVitals.date,
    eventSubHeader: itemSubHeader,
    rowActionType: TimelineConstants.SET_HOSPITAL_NOTIFY_PROCEDURE_ITEM,
    defaultHref: TabConstants.HOSPITAL_NOTIFY_PROCEDURE,
    date: new Date(procedureEvent.dtDevice),
    clientEventId: clientEventId,
    ...(vsAction && { vsAction: vsAction }),
    ...(isEkgImport && { isEkgImport: isEkgImport }),
  }

  let hospitalNotifyState: IHospitalNotifyState = {
    key: clientEventId,
    method: methodOption ?? null,
    alertType: null,
    alertTypePNNV: null,
    potentialRegistry: [],
    assessedBy: null,
    comments: itemComments,
    addToTimeline: false,
    updateInputRows: false,
    date: procedureEvent.eventVitals.date,
    time: procedureEvent.eventVitals.time,
    successfulAttempt: true,
    pta: isPTA,
    attempts: '1',
    type: 'Hospital Notify',
    rolePerforming: null,
    rolePerformingPNNV: null,
    isEkgImport: 1,
    nemsisCode: null,
    procedurePerformedByAnotherUnit: null,
    procedurePerformedByAnotherUnitPNNV: null,
  }

  try {
    hospitalNotifyState = getUpdatedProcedureStateWithNemsisCode({
      procedureState: hospitalNotifyState,
      actionField: (s) => s.method?.name,
      filter1Field: null,
      filter2Field: null,
      filter3Field: null,
      nemsisCodeOptions,
    })
  } catch (error: unknown) {
    hospitalNotifyState = handleNemsisCodeError(error, hospitalNotifyState)
  }
  const newHospitalNotifyProcedure: HospitalNotifyProcedureObject = {
    hospitalNotifyState,
    timelineItem,
  }

  return newHospitalNotifyProcedure
}

export default createHospitalNotifyProcedure
